import { Extensions } from './Extensions'

export class SimpleItemListExtensions extends Extensions {}
